import { takeLatest } from "redux-saga/effects"

import { apiGeneratorBase } from "../../Utils/saga"
import Creators, { BalanceTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getBalanceActions: {
    request: Creators.getBalanceRequest,
    success: Creators.getBalanceSuccess,
    errors: Creators.balanceFailure
  },
  updateBalanceActions: {
    request: Creators.updateBalanceRequest,
    success: Creators.updateBalanceSuccess,
    errors: Creators.balanceFailure
    //extraAction: [BusinessAccountsActions.getStatisticsAdminRequest],
  },
  topUpBalanceActions: {
    request: Creators.topUpBalanceRequest,
    success: Creators.topUpBalanceSuccess,
    errors: Creators.topUpBalanceFailure,
    redirect: "/manual-top-up"
  },
  firstTopUpBalanceActions: {
    request: Creators.firstTopUpBalanceRequest,
    success: Creators.firstTopUpBalanceSuccess,
    errors: Creators.firstTopUpBalanceFailure,
    redirect: "/manual-top-up"
  },
  getBalanceActivityActions: {
    request: Creators.getBalanceActivityRequest,
    success: Creators.getBalanceActivitySuccess,
    errors: Creators.balanceFailure
  },
  getBalanceActivityExportActions: {
    request: Creators.getBalanceActivityExportRequest,
    success: Creators.getBalanceActivityExportSuccess,
    errors: Creators.getBalanceActivityExportFailure
  },
  getBalanceActivityFilterOptionsActions: {
    request: Creators.getBalanceActivityFilterOptionsRequest,
    success: Creators.getBalanceActivityFilterOptionsSuccess,
    errors: Creators.getBalanceActivityFilterOptionsFailure
  }
}

const eventsOptions = {
  [constants.GET_BALANCE_REQUEST]: {
    api: services.getBalance,
    actions: actions.getBalanceActions
  },
  [constants.UPDATE_BALANCE_REQUEST]: {
    api: services.updateBalance,
    actions: actions.updateBalanceActions
  },
  [constants.TOP_UP_BALANCE_REQUEST]: {
    api: services.topUpBalance,
    actions: actions.topUpBalanceActions
  },
  [constants.FIRST_TOP_UP_BALANCE_REQUEST]: {
    api: services.firstTopUpBalance,
    actions: actions.firstTopUpBalanceActions
  },
  [constants.GET_BALANCE_ACTIVITY_REQUEST]: {
    api: services.getBalanceActivity,
    actions: actions.getBalanceActivityActions
  },
  [constants.GET_BALANCE_ACTIVITY_EXPORT_REQUEST]: {
    api: services.getBalanceActivityExport,
    actions: actions.getBalanceActivityExportActions
  },
  [constants.GET_BALANCE_ACTIVITY_FILTER_OPTIONS_REQUEST]: {
    api: services.getBalanceActivityFilterOptions,
    actions: actions.getBalanceActivityFilterOptionsActions
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_BALANCE_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_BALANCE_REQUEST])
  )
  yield takeLatest(constants.UPDATE_BALANCE_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.UPDATE_BALANCE_REQUEST])
  )
  yield takeLatest(constants.TOP_UP_BALANCE_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.TOP_UP_BALANCE_REQUEST])
  )
  yield takeLatest(constants.FIRST_TOP_UP_BALANCE_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.FIRST_TOP_UP_BALANCE_REQUEST])
  )
  yield takeLatest(constants.GET_BALANCE_ACTIVITY_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_BALANCE_ACTIVITY_REQUEST])
  )
  yield takeLatest(constants.GET_BALANCE_ACTIVITY_EXPORT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_BALANCE_ACTIVITY_EXPORT_REQUEST])
  )
  yield takeLatest(constants.GET_BALANCE_ACTIVITY_FILTER_OPTIONS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_BALANCE_ACTIVITY_FILTER_OPTIONS_REQUEST])
  )
}
